import Icon from '@mdi/react'
import styled from 'styled-components'
import theme from 'theme_'
import { SubInfoBlock } from '../styles'
import { Font12, Font14, SectionLabel } from 'components/Typography'

export const AppliedLicensesEmpty = styled.div`
  align-items: center;
  color: ${theme.colors.duneWarmGrey};
  display: flex;
  justify-content: center;
  height: 100%;
`

export const AppliedLicensesBlock = styled(SubInfoBlock)`
  padding: 12px 0 24px 0;
  @media ${theme.devices.tablet} {
    padding: 12px 24px 24px 24px;
  }
`

export const AppliedLicensesHeader = styled(SectionLabel)`
  padding: 0 ${theme.spacing.md};

  @media ${theme.devices.tablet} {
    padding: 0;
  }
`

export const MobileLicensesList = styled.div`
  display: block;
  @media ${theme.devices.tablet} {
    display: none;
  }
`

export const DesktopLicensesList = styled.div`
  display: none;
  @media ${theme.devices.tablet} {
    display: flex;
    gap: ${theme.spacing.xs};
    flex-wrap: wrap;
  }
`

export const AppliedLicenseWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  outline: none;
  @media ${theme.devices.tablet} {
    padding: 0;
    flex: 1 1 30%;
    max-width: 33%;
  }
`

export const AppliedLicense = styled.div`
  align-items: flex-start;
  display: flex;
  background-color: ${theme.colors.lighterGrey};
  border-radius: 8px;
  ${Font14};
  padding: 8px 12px;
  min-height: 68px;
  width: 100%;
  height: 100%;
`

export const AppliedLicenseIcon = styled(Icon)`
  color: ${theme.colors.dolphinGrey};
  margin-right: 12px;
  flex-shrink: 0;
`
export const AppliedLicenseInfo = styled.div`
  display: flex;
  flex-direction: column;
`

export const AppliedLicenseDescription = styled.div`
  ${Font14};
  margin-bottom: 4px;
`

export const AppliedLicenseName = styled.div`
  color: ${theme.colors.duneWarmGrey};
  ${Font12};
`
